const state = {
    /** @type {HTMLElement} */
    toast: undefined,
    toastBody: undefined,
    toastBootstrap: undefined,
};

/**
* Basic initializer to setup state (should be called on dom load from within an app)
* @param {*} bootstrap
*/
function initializeToaster(bootstrap) {
    state.toast = document.getElementById('toastTemplate');
    state.toastBody = document.getElementById('toastTemplate').querySelector('.toast-body');
    state.toastBootstrap = bootstrap.Toast.getOrCreateInstance(state.toast)
}

function triggerToast(content) {
    if (!state.toast) {
        return false;
    }

    state.toastBody.innerText = content;
    state.toastBootstrap.show();

}

export {
    initializeToaster,
    triggerToast
}
